import React from "react";
import { motion } from "framer-motion";

import "./styles.css";
import WorkCard from "../components/WorkCard";
import FancyButton from "../components/FancyButton";
import { BEHANCE_URL, DRIBBBLE_URL, EMAIL } from "../layout/contact";
import usePageMeta from "../hooks/usePageMeta";
import { designWork, products } from "../data/projects";

export default function Work() {
	usePageMeta(
		"Work",
		"Selected product and UI design work by Muhammad Munaf, a product engineer in Islamabad, Pakistan."
	);

	const variants = {
		hidden: { opacity: 0, y: 100 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<main id="main-content" tabIndex={-1}>
			<div className="featured-work full-page">
				<motion.h1
					className="page-title black-text"
					initial="hidden"
					animate="visible"
					variants={variants}
					transition={{ duration: 0.6 }}
				>
					Work
				</motion.h1>

				{products.length > 0 && (
					<WorkSection
						id="products"
						title="Products & Experiments"
						intro="What I’m building now."
						projects={products}
					/>
				)}

				<WorkSection
					id="selected-work"
					title="Selected Design Work"
					intro="Product and UI design from my design career."
					projects={designWork}
				/>

				<aside className="more-work" aria-label="More work">
					<p className="sm black">
						There’s more work that isn’t here yet. Browse my portfolio
						deck, Behance or Dribbble, or ask me for a walkthrough.
					</p>
					<div className="hero-actions">
						<FancyButton
							label="View portfolio deck (PDF)"
							linkTo="/munaf-portfolio-deck.pdf"
							external
							black
							ariaLabel="View my portfolio deck, PDF, 12 MB (opens in a new tab)"
						/>
						<FancyButton
							label="Behance"
							linkTo={BEHANCE_URL}
							external
							ariaLabel="View my Behance portfolio (opens in a new tab)"
						/>
						<FancyButton
							label="Dribbble"
							linkTo={DRIBBBLE_URL}
							external
							ariaLabel="View my Dribbble portfolio (opens in a new tab)"
						/>
						<FancyButton
							label="Ask for a walkthrough"
							linkTo={`mailto:${EMAIL}?subject=More%20of%20your%20work`}
							external
							ariaLabel={`Email me at ${EMAIL} to see more work`}
						/>
					</div>
				</aside>
			</div>
		</main>
	);
}

function WorkSection({ id, title, intro, projects }) {
	return (
		<section className="work-section" aria-labelledby={`${id}-title`}>
			<header className="work-section-header">
				<h2 id={`${id}-title`} className="section-title">
					{title}
				</h2>
				<p className="xs black">{intro}</p>
			</header>
			{projects.map((project, index) => (
				<WorkCard
					key={project.slug}
					project={project}
					left={index % 2 === 1}
					white
				/>
			))}
		</section>
	);
}
